import dayjs, { Dayjs } from 'dayjs';
import { revertTransformDate } from '@lib/utils/dateTimeHelpers';
import {
  MaskitoDateMode,
  maskitoDateRangeOptionsGenerator,
} from '@maskito/kit';
import { dateFormat } from '@lib/enums/dateTime';

const useSelectedDate = ({
  value,
  format,
  isFocused,
}: {
  value?: string[];
  format: string;
  isFocused?: boolean;
}) => {
  let selected: [Dayjs | null, Dayjs | null] | null = null;
  const isValueExists = !!(Array.isArray(value) && value?.[0] && value?.[1]);
  if (isValueExists) {
    selected = [
      dayjs(revertTransformDate(value[0])),
      dayjs(revertTransformDate(value[1])),
    ];
  }
  const inputValue = selected
    ? `${selected[0]?.format(format) || ''} – ${selected[1]?.format(format) || ''}`
    : '';
  const placeholder = isFocused
    ? `${format} - ${format}`.toUpperCase()
    : undefined;
  const mask = maskitoDateRangeOptionsGenerator({
    mode: dateFormat.toLowerCase() as MaskitoDateMode,
    dateSeparator: '/',
  });
  return { mask, selected, inputValue, placeholder, isValueExists };
};

export default useSelectedDate;
